import React, { useState, useEffect } from 'react';
import WorkflowStatus from './WorkflowStatus';
import { getWorkflows } from "../utils/github";

function RenderMainPage() {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    // Fetch GitHub workflow data
    const fetchData = async () => {
        setLoading(true);
        setError(null);
        try {
            const response = await getWorkflows(); // Await the promise from getWorkflows
            const responseData = await response.json(); // Convert the response to JSON

            console.log('response data:', responseData);

            if (response.ok) { // Check if the response is OK (status 200)
                setData(responseData.workflowsForRepos); // Set the data from the response
            } else {
                setError("Failed to fetch workflows.");
            }
        } catch (error) {
            setError("An error occurred while fetching data.");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchData();
    }, []);

    return (
        <div>
            <WorkflowStatus
                loading={loading}
                error={error}
                data={data}
                fetchData={fetchData}
            />
        </div>
    );
}

export default RenderMainPage;
